import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState } from 'react';
import { Dialog, Button, Text, Flex, Notice, Card } from '@applyboard/crystal-ui';
import { EmailOutlineIcon, CheckCircleOutlineIcon, LockOpenOutlineIcon } from '@applyboard/ui-icons';
import { SHARED_ACCESS_BENEFITS_LIST, SHARED_ACCESS_DESCRIPTION_LIST } from "./const";
import { useEventTracker } from '@applyboard/ui-utils';
import { getCurrentEpochTimeInSeconds } from "./util";
import { useSendStudentInvitation } from "../../../data";
import { InviteStudentSuccessDialog } from "./InviteStudentSuccessDialog";
import { SelfServeStudentAccessDialogsContainer } from "../SelfServeStudentAccessDialogsContainer";
var CustomListItem = function CustomListItem(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Flex, {
    gap: 4,
    align: "center",
    role: "listitem"
  }, children);
};
export var SelfServeStudentAccessDialog = function SelfServeStudentAccessDialog(_ref2) {
  var isOpen = _ref2.isOpen,
    setIsOpen = _ref2.setIsOpen,
    onSubmit = _ref2.onSubmit,
    studentUserId = _ref2.studentUserId,
    studentEmail = _ref2.studentEmail,
    studentFullName = _ref2.studentFullName,
    pageCaller = _ref2.pageCaller;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSendStudentInvitationSuccess = _useState2[0],
    setIsSendStudentInvitationSuccess = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSendStudentInvitationError = _useState4[0],
    setIsSendStudentInvitationError = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    triggerOnDismissFlow = _useState6[0],
    setTriggerOnDismissFlow = _useState6[1];
  var _useSendStudentInvita = useSendStudentInvitation(),
    sendStudentInvitation = _useSendStudentInvita.sendStudentInvitation,
    isSendingStudentInvitation = _useSendStudentInvita.isSendingStudentInvitation;
  var handleSubmit = function handleSubmit() {
    if (onSubmit) {
      onSubmit();
    }
    sendStudentInvitation({
      studentUserId: studentUserId
    }, {
      onSuccess: function onSuccess() {
        setIsSendStudentInvitationSuccess(true);
      },
      onError: function onError() {
        setIsSendStudentInvitationError(true);
      }
    });
  };
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    openTime = _useState8[0],
    setOpenTime = _useState8[1];
  useEffect(function () {
    if (isOpen) {
      setOpenTime(getCurrentEpochTimeInSeconds());
    }
  }, [isOpen]);
  var resetSendStudentInvitationState = function resetSendStudentInvitationState() {
    setIsSendStudentInvitationError(false);
    setIsSendStudentInvitationSuccess(false);
    setTriggerOnDismissFlow(false);
  };
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  if (isSendStudentInvitationSuccess) {
    return /*#__PURE__*/React.createElement(InviteStudentSuccessDialog, {
      isOpen: isOpen,
      setIsOpen: setIsOpen,
      sentToEmail: studentEmail,
      studentFullName: studentFullName,
      onDialogClose: resetSendStudentInvitationState
    });
  }
  if (triggerOnDismissFlow) {
    return /*#__PURE__*/React.createElement(SelfServeStudentAccessDialogsContainer, {
      triggerOnDismissFlow: triggerOnDismissFlow,
      onClose: resetSendStudentInvitationState,
      pageCaller: pageCaller
    });
  }
  return /*#__PURE__*/React.createElement(Dialog, {
    open: isOpen,
    onOpenChange: function onOpenChange(newOpenState) {
      setIsOpen(newOpenState);
      resetSendStudentInvitationState();
      var totalTimeDialogOpenedInSeconds = getCurrentEpochTimeInSeconds() - openTime;
      trackEvent({
        event: 'Self Serve Student Actions - Dismissed Modal',
        data: {
          page: pageCaller,
          duration_time_opened: totalTimeDialogOpenedInSeconds
        }
      });
      setTriggerOnDismissFlow(true);
    }
  }, /*#__PURE__*/React.createElement(Dialog.Panel, null, /*#__PURE__*/React.createElement(Dialog.Heading, null, "Self-serve student access"), /*#__PURE__*/React.createElement(Dialog.Content, null, /*#__PURE__*/React.createElement(Flex, {
    direction: "column",
    gap: 6
  }, isSendStudentInvitationError ? /*#__PURE__*/React.createElement(Notice, {
    intent: "negative",
    width: "fill"
  }, "We could not connect to the server. Refresh the browser window or try again later.") : /*#__PURE__*/React.createElement(Notice, {
    intent: "primary",
    width: "fill"
  }, "By providing the student with direct access to ApplyBoard, you\u2018ll still be able to see and modify any changes they make. The student will NOT be able to access the commissions related information or receive and view any notes from ApplyBoard. Once access is shared with the student, it cannot be revoked."), /*#__PURE__*/React.createElement(Text, {
    variant: "titleS"
  }, "Shared access benefits"), /*#__PURE__*/React.createElement(Card, {
    as: "section",
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(Card.Header, null, /*#__PURE__*/React.createElement(Text, {
    intent: "secondary"
  }, "Extending access could help with the following:"), /*#__PURE__*/React.createElement("div", {
    role: "list"
  }, /*#__PURE__*/React.createElement(Flex, {
    pt: 6,
    pb: 2,
    direction: "column",
    gap: 6
  }, SHARED_ACCESS_BENEFITS_LIST.map(function (benefit) {
    return /*#__PURE__*/React.createElement(CustomListItem, {
      key: benefit.id
    }, /*#__PURE__*/React.createElement(CheckCircleOutlineIcon, {
      intent: "positive"
    }), /*#__PURE__*/React.createElement(Text, {
      intent: "secondary"
    }, benefit.description));
  }))))), /*#__PURE__*/React.createElement(Text, {
    variant: "titleS"
  }, "Shared access details"), /*#__PURE__*/React.createElement(Card, {
    as: "section",
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(Card.Header, null, /*#__PURE__*/React.createElement(Text, {
    intent: "secondary",
    id: "shared-access-description"
  }, "The student will receive an email invitation to the platform, giving them access to do the following:"), /*#__PURE__*/React.createElement("div", {
    role: "list"
  }, /*#__PURE__*/React.createElement(Flex, {
    pt: 6,
    pb: 2,
    direction: "column",
    gap: 6
  }, SHARED_ACCESS_DESCRIPTION_LIST.map(function (description) {
    return /*#__PURE__*/React.createElement(CustomListItem, {
      key: description.id
    }, /*#__PURE__*/React.createElement(LockOpenOutlineIcon, {
      intent: "positive"
    }), /*#__PURE__*/React.createElement(Text, {
      intent: "secondary"
    }, description.description));
  }))))))), /*#__PURE__*/React.createElement(Dialog.Actions, null, /*#__PURE__*/React.createElement(Button, {
    width: "fill",
    variant: "highlighted",
    intent: "secondary",
    onClick: function onClick() {
      var totalTimeDialogOpenedInSeconds = getCurrentEpochTimeInSeconds() - openTime;
      trackEvent({
        event: 'Self Serve Student Actions - Clicked No Thanks',
        data: {
          page: pageCaller,
          duration_time_opened: totalTimeDialogOpenedInSeconds
        }
      });
      setIsOpen(false);
      setTriggerOnDismissFlow(true);
    }
  }, "No, thanks"), /*#__PURE__*/React.createElement(Button, {
    disabled: isSendingStudentInvitation,
    intent: "primary",
    width: "fill",
    leadIcon: EmailOutlineIcon,
    onClick: function onClick() {
      handleSubmit();
      var totalTimeDialogOpenedInSeconds = getCurrentEpochTimeInSeconds() - openTime;
      trackEvent({
        event: 'Self Serve Student Actions - Clicked Share Access',
        data: {
          page: pageCaller,
          duration_time_opened: totalTimeDialogOpenedInSeconds
        }
      });
    }
  }, "Share access"))));
};